import NDialog from './NDialog';
export { NDialog }
export default NDialog;